import { event } from 'vue-analytics'

export default (context, category, action, label = null, id = null) => {
  if (process.env.NODE_ENV === 'production') {
    if (context) {
      context.$ga.event(category, action, label, id)
    } else {
      event(category, action, label, id)
    }
  } else {
    console.warn('trackAnalytics', category, action, label, id)
  }
}


export const setUserId = (context, userId) => {
  if (!userId) {
    console.log("empty user ID")
    return
  }
  if (!context.$ga) {
    console.log("empty context.$ga")
    return
  }

  if (process.env.NODE_ENV === 'production') {
    console.log("tracking user id", userId)
    context.$ga.set('userId', userId)
  } else {
    console.warn('userId', userId)
  }
}
